import type { Metadata } from "next";
import { SITE_TITLE } from "./webConst";

export const SITE_URL = "https://klap.app";
export const DEFAULT_TITLE = `Klap | ${SITE_TITLE}`;
export const DEFAULT_OG_IMAGE_URL = `${SITE_URL}/images/og.jpg`;
export const DEFAULT_OG_IMAGE = {
  url: DEFAULT_OG_IMAGE_URL,
  width: 1200,
  height: 630,
  alt: "Klap — turn videos into viral shorts",
};

type SocialMetaArgs = {
  title: string;
  description: string;
  /** Page-relative path or absolute URL; `metadataBase` resolves relative paths. */
  url?: string;
};

/**
 * Build a complete `openGraph` block. Use this whenever a page overrides
 * OG fields, because Next.js does NOT deep-merge `openGraph` with the parent
 * layout — defining `openGraph` in a child page replaces the layout's entire
 * block, including the default image.
 */
export function buildOpenGraph(args: SocialMetaArgs): NonNullable<Metadata["openGraph"]> {
  return {
    type: "website",
    siteName: "Klap",
    url: args.url,
    title: args.title,
    description: args.description,
    images: [DEFAULT_OG_IMAGE],
  };
}

/**
 * Build a complete `twitter` block. Same caveat as `buildOpenGraph`: Next.js
 * replaces (rather than merges) the parent's `twitter` field when a child
 * defines its own.
 */
export function buildTwitter(args: SocialMetaArgs): NonNullable<Metadata["twitter"]> {
  return {
    card: "summary_large_image",
    title: args.title,
    description: args.description,
    images: [DEFAULT_OG_IMAGE_URL],
  };
}
